@if (whiteLabelService.isV2Skin() && (manualLoading() || (httpLoading$ | async))) {
	<output class="v2-diamond-loader" aria-live="polite" aria-label="Loading"></output>
}
